export default {
  title: {
    id: 'service_drawer_how_it_works_title',
    defaultMessage: 'How it works',
  },
  step1Title: {
    id: 'service_drawer_how_it_works_step1_title',
    defaultMessage: 'Submit a request:',
  },
  step1: {
    id: 'service_drawer_how_it_works_step1',
    defaultMessage:
      'Log in to your Back Market account, go to the Protection plans tab and submit a repair request. Takes less than 5 minutes.',
  },
  step2Title: {
    id: 'service_drawer_how_it_works_step2_title',
    defaultMessage: 'Get a decision in 24 hours:',
  },
  step2: {
    id: 'service_drawer_how_it_works_step2',
    defaultMessage:
      'No justification needed. Our team assesses your situation and confirms your solution.',
  },
  step3Title: {
    id: 'service_drawer_how_it_works_step3_title',
    defaultMessage: 'We sort it:',
  },
  step3: {
    id: 'service_drawer_how_it_works_step3',
    defaultMessage:
      "Depending on the fault, we'll either, at our discretion, repair your device or provide a credit toward a replacement on Back Market.",
  },
}
